import { 
    AppEnum, 
    FaHashtag, 
    FaSearch, 
    FaUser, 
    Header,
    OPERATORS,
    UserEnums,
 } from "@/Shared";

import { UserViewModel } from "./ViewModels";


export type SelectOption = {
    value : any,
    label : any
}

export class UserHeader {

    private constructor() { }

    get id() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        }
    }

    get civility() {
        return {
            key: 'civility',
            icon: <FaUser />,
            label: 'Civilité',
            type: 'string',
            isSortable: true
        }
    }
    get name() {
        return {
            key: 'fullName',
            icon: <FaSearch />,
            label: 'Nom ou Prénom',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Par nom",
                case: 'insensitive'
            }
        }
    }
    

    get manager() {
        return {
            key: 'managerName',
            icon: <FaSearch />,
            label: 'Manager',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Par Manager",
                case: 'insensitive'
            }
        }
    }

    getPositions(UserPositionEnum : AppEnum[]) {
        return {
            key: 'positions',
            icon: <FaUser />,
            label: 'Fonctions',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Par Fonction",
                case: 'insensitive',
                operator: OPERATORS.CONTAINS,
                options: UserPositionEnum,
            }
        }
    }

     getRole(UserRoleEnum : AppEnum[]) {
        return {
            key: 'role',
            icon: <FaUser />,
            label: 'Rôle',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Par rôle",
                case: 'insensitive',
                operator: OPERATORS.CONTAINS,
                options: UserRoleEnum,
            }
        }
    }

    static build(viewEnums: UserEnums): Record<keyof UserViewModel, Header<UserViewModel>> {
        const header = new UserHeader();
        return {
            id: header.id,
            civility: header.civility,
            fullName: header.name,
            role : header.getRole(viewEnums.UserRoleEnum),
            positions : header.getPositions(viewEnums.UserPositionEnum),
            managerName : header.manager,
        } as Record<keyof UserViewModel, Header<UserViewModel>>
    }
}